import { useContext } from "react";
import { Redirect } from "react-router-dom";
import { RootStoreContext } from "../../stores/RootStore";

export const LogOut = () => {
  const rootStore = useContext(RootStoreContext);
  rootStore.authorizationStore.removeAuthToken();

  return <Redirect to="/login" />
}